import {
    Button,
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography
} from '@mui/material';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { BsArrowCounterclockwise } from "react-icons/bs";
import { apiService } from '../../api/axiosClient';

const currencyLocale = Intl.NumberFormat('ko-KR');

const SummaryPage = ({ order, reload, setReload }) => {
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm()

    useEffect(() => {
        const defaultValues = {
            order_payment: order?.order_payment,
            order_supply_price: order?.order_supply_price,
            order_final: order?.order_final,
            order_memo: order?.order_memo
        }
        reset(defaultValues);
    }, [reset, order]);

    const onSubmit = async (data, e) => {
        const params = {
            "order_payment": data.order_payment,
            "order_memo": data.order_memo
        };

        try {
            await apiService.put(`/orders/summary/${order.orderid}`, params);
            toast.success('업데이트 되었습니다.');
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <Card>
            <CardHeader title='주문 정보' titleTypographyProps={{ variant: 'h6' }} />
            <CardContent>
                <form onSubmit={handleSubmit(onSubmit)} id="summaryform">
                    <Grid container spacing={6}>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <InputLabel id='order_payment'>결제방법</InputLabel>
                                <Controller
                                    name='order_payment'
                                    control={control}
                                    defaultValue=''
                                    rules={{ required: true }}
                                    renderValue={selected => (selected.length === 0 ? '' : selected)}
                                    render={({ field: { value, onChange } }) => (
                                        <Select
                                            label='결제방법'
                                            value={value}
                                            onChange={onChange}
                                            labelId='order_payment'
                                            error={Boolean(errors.order_payment)}
                                        >
                                            <MenuItem value="신용카드">신용카드</MenuItem>
                                            <MenuItem value="무통장">무통장</MenuItem>
                                            <MenuItem value="계좌이체">계좌이체</MenuItem>
                                        </Select>
                                    )}
                                />
                                {errors.order_payment && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-order_payment'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                    
                        <Grid item xs={12} sm={4}>
                            <Typography variant="subtitle"> 공급가 </Typography>
                            <Typography variant="body1" sx={{ mt: 1 }}>
                                {currencyLocale.format(order?.order_supply_price)}원
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Typography variant="subtitle"> 주문가 </Typography>
                            <Typography variant="body1" sx={{ mt: 1 }}>
                                {currencyLocale.format(order?.order_final)}원
                            </Typography>
                        </Grid>

                        <Grid item xs={12} >
                            <FormControl fullWidth>
                                <Controller
                                    name='order_memo'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='메모'
                                            rows={4}
                                            multiline
                                            id='order_memo'
                                            onChange={onChange}
                                            placeholder='메모를 입력해주세요'
                                            error={Boolean(errors.order_memo)}
                                            aria-describedby='validation-async-order_memo'
                                        />
                                    )}
                                />
                                {errors.order_memo && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-order_memo'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sx={{ pt: theme => `${theme.spacing(7)} !important` }}>
                            <Button type="submit" form="summaryform" variant='contained' sx={{ mr: 4 }}>
                                수정
                            </Button>
                            <Button variant='contained' color='success' startIcon={<BsArrowCounterclockwise />} onClick={() => setReload(reload + 1)}>
                                새로고침
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}

export default SummaryPage
